import {
    URLAPI,
    CATEGORY_MAINTENANCE_PATH,
    CATEGORY_MAINTENANCE_CREATE_PATH,
    CATEGORY_MAINTENANCE_UPDATE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_category_maintenance: {
        data: [],

        status: 0,
        message: {},
    },

    _create_category_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_category_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_CATEGORY_MAINTENANCE = "GET_ALL_CATEGORY_MAINTENANCE";
export const CREATE_CATEGORY_MAINTENANCE = "CREATE_CATEGORY_MAINTENANCE";
export const UPDATE_CATEGORY_MAINTENANCE = "UPDATE_CATEGORY_MAINTENANCE";

export const category_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_CATEGORY_MAINTENANCE:
            return {
                ...state,
                _get_all_category_maintenance: action.payload,
            };
        case CREATE_CATEGORY_MAINTENANCE:
            return {
                ...state,
                _create_category_maintenance: action.payload,
            };
        case UPDATE_CATEGORY_MAINTENANCE:
            return {
                ...state,
                _update_category_maintenance: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllCategoryMaintenance = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${CATEGORY_MAINTENANCE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_CATEGORY_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_CATEGORY_MAINTENANCE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_CATEGORY_MAINTENANCE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createCategoryMaintenance = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${CATEGORY_MAINTENANCE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_CATEGORY_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_CATEGORY_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_CATEGORY_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateCategoryMaintenance = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${CATEGORY_MAINTENANCE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_CATEGORY_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_CATEGORY_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_CATEGORY_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_category_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
